import React from 'react';
import { Box, Typography, Container, Paper, Divider, Link } from '@mui/material';

const PaymentRefund = () => {
  const handleTermsClick = () => {
    window.open('/terms', '_blank');
  };

  const handlePrivacyClick = () => {
    window.open('/privacy', '_blank');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'rgba(228, 228, 228, 0.6)',
        py: 4
      }}
    >
      <Container maxWidth="lg">
        <Paper elevation={2} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h3" component="h1" sx={{ mb: 3, textAlign: 'center', fontWeight: 600, color: 'primary.main'}}>
            PageSmooth 充值与退款说明
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
            生效日期：2025年6月20日 | 最后更新：2025年6月20日
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            尊敬的用户，为了让您更好地了解PageSmooth的充值与退款政策，请仔细阅读以下说明。本说明是
            <Link
              onClick={handleTermsClick}
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              《PageSmooth用户服务协议》
            </Link>
            的重要组成部分，与
            <Link
              onClick={handlePrivacyClick}
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              《PageSmooth用户隐私政策》
            </Link>
            具有同等法律效力。
          </Typography>
          
          <Divider sx={{ mb: 4 }} />
          
          <Box sx={{ '& > *': { mb: 4 } }}>
            {/* 第一章 充值说明 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第一章 充值说明
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第一条 充值方式</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  PageSmooth支持以下充值方式：仅支持微信支付；
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二条 点数套餐</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  PageSmooth提供多种点数套餐供用户选择：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>体验套餐：适合个人体验使用；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>超值套餐：包含赠送点数，性价比更高；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>尊享套餐：大量充值享受更多优惠；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>定制套餐：根据企业需求量身定制。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三条 充值到账</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  用户完成支付后，点数将立即到账并可正常使用。如遇到充值异常情况，请及时联系客服处理。充值记录可在个人中心查看，包含充值时间、金额、获得点数等详细信息。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四条 发票服务</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth为企业用户提供正规发票服务，支持增值税普通发票。用户可在充值后联系客服。
                </Typography>
              </Box>
            </Box>

            {/* 第二章 点数使用规则 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第二章 点数使用规则
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第五条 计费标准</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  翻译服务按页消耗点数，具体计费规则如下：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>AI5.0翻译：每页消耗1点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>专业认证服务：每页消耗7点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>NAATI认证服务：每页消耗7点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>加急服务：每页额外消耗3点数。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第六条 点数有效期</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  用户购买的点数永不过期，可随时使用。点数仅可用于PageSmooth平台的翻译服务，不可转让给其他用户或兑换现金。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第七条 点数扣除与退还</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  点数扣除和退还规则：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译任务创建时立即扣除相应点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译成功完成后，点数不可退还；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>系统故障导致翻译失败时，自动退还已扣除的点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>点数退还将在24小时内完成；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户可在个人中心查看详细的点数消费记录。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第三章 退款政策 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第三章 退款政策
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第八条 虚拟商品特性</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  点数包作为虚拟商品，使用期限为永久有效。根据《消费者权益保护法》相关规定，虚拟商品一经购买使用，原则上不支持退款。用户在购买前应充分了解商品特性和使用规则。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第九条 特殊退款情形</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  以下特殊情况下，用户可申请退款：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>系统故障导致重复扣费；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>支付成功但点数未到账且无法修复；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>其他经PageSmooth认定的合理退款情形。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十条 退款申请流程</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  用户申请退款需按以下流程操作：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>在充值后7日内通过平台客服提出退款申请；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>提供充值订单号、支付凭证等相关材料；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>说明退款原因并配合客服核实情况；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>PageSmooth审核通过后，将在5-10个工作日内完成退款；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>退款将原路返回至用户支付账户。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十一条 退款限制</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  以下情况不支持退款：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>已使用部分或全部点数进行翻译服务；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>超过7日退款申请期限；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>无法提供有效的购买凭证；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>恶意申请退款或存在欺诈行为；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>违反平台使用规则的用户。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第四章 常见问题 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第四章 常见问题
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>问：实际翻译怎么计费？</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  答：我们按照标准 A4 页面计算，图片按1页计算，PDF等文档按实际页数计算。系统会自动识别并计算您上传文档的页数。
                </Typography>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>问：PDF每一页所能容纳的证件数量？</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  答：根据平台翻译的特性，为确保每一页翻译的质量，按照标准的A4纸页面，原始上传的每一页必须仅包含一个证件，对于容纳多个证件的情况，平台有权进行取消翻译等处理。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>问：可以随时购买或变更点数包套餐吗？</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  答：是的，您可以随时购买或变更点数包，购买立即生效。点数包作为虚拟商品，使用期限为永久有效，不支持退款。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>问：什么情况下可以申请退款？</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  答：由于点数包属于虚拟商品，原则上不支持退款。但在系统故障导致重复扣费、支付成功但点数未到账等特殊情况下，可在7日内联系客服申请退款。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>问：充值后多久到账？</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  答：正常情况下，用户完成支付后点数将立即到账。如遇充值异常，请及时联系客服处理，我们会在24小时内为您解决问题。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>问：企业用户有什么优惠政策？</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  答：企业用户可享受大量充值优惠、专属定制方案、企业级服务保障、专属客户经理、7×24小时支持、数据安全保障和发票开具服务。具体优惠请联系客服咨询。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>问：点数会过期吗？</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  答：不会。用户购买的点数永不过期，可随时使用。点数仅可用于PageSmooth平台的翻译服务，不可转让给其他用户或兑换现金。
                </Typography>
              </Box>
            </Box>

            {/* 第五章 联系方式 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第五章 联系方式
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十二条 客服支持</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  如您在充值或退款过程中遇到任何问题，可通过以下方式联系我们：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>在线客服：登录PageSmooth平台，工作时间点击客服按钮；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>客服邮箱：support@pagesmooth.com；</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十三条 服务承诺</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth承诺为用户提供优质的充值和退款服务，确保用户资金安全，及时处理用户问题。我们将持续优化服务流程，提升用户体验。
                </Typography>
              </Box>
            </Box>
          </Box>
          
          <Divider sx={{ mb: 4 }} />
          
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            本说明的最终解释权归郑州译悦翻译有限公司所有。如有疑问，请联系客服咨询。
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentRefund;